import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { palette } = lightTheme;
const styles: Record<string, SxProps> = {
  // Base styles for container
  base: {
    fontWeight: '400',
    fontSize: '0.875rem',
    width: 'calc(100% - 16px)',
    borderRadius: '0.5rem',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: '8px',
    marginRight: '8px',
    px: {
      xs: '0.75rem',
      md: '1rem'
    },
    py: {
      xs: '0.25rem',
      md: '0.625rem'
    },
    minHeight: {
      md: '4.5rem',
      xs: '3.25rem'
    },

    '.MuiAlert-icon': {
      height: { xs: '1.75rem', md: '2.25rem' },
      width: { xs: '1.75rem', md: '2.25rem' },
      borderRadius: '0.25rem',
      margin: '0.25em 0.50em 0.25em 0',
      backgroundColor: palette.grey['50'],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: { xs: '0.4rem', md: '1.125rem' },
      opacity: '1'
    },
    '.MuiAlert-message .MuiBox-root': {
      marginTop: 0
    },
    // class to style close icon on right
    '.MuiAlert-action': {
      display: 'none',
      alignItems: 'center'
    },
    // class to style Alert-title text
    '.MuiAlertTitle-root': {
      marginBottom: '0.2em',
      fontSize: '1rem',
      fontWeight: '700',
      lineHeight: '1.125rem',
      textTransform: 'lowercase',
      whiteSpace: 'pre-wrap',
      '&::first-letter': {
        textTransform: 'uppercase'
      }
    }
  },
  description: {
    lineHeight: {
      xs: '1rem',
      md: '1.25rem'
    }
  },
  title: {
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: {
      xs: '1rem',
      md: '1.25rem'
    }
  },
  // class to style bottom buttom
  link: {
    fontSize: '0.875rem',
    fontWeight: '800',
    lineHeight: '0.875rem',
    boxShadow: 'none',
    textAlign: 'left',
    padding: '0',
    justifyContent: 'flex-start',
    display: 'block',
    textTransform: 'lowercase',
    '&::first-letter': {
      textTransform: 'uppercase'
    }
  },
  // styles to alter color of alert
  success: {
    backgroundColor: palette.seaGreen.main,
    color: palette.grey['50']
  },
  warning: {
    backgroundColor: palette.secondary['300'],
    color: palette.grey.main
  },
  error: {
    border: '1px solid',
    color: palette.grey.main,
    backgroundColor: palette.brightRed[900],
    borderColor: palette.bloodRed[100]
  },
  info: {
    border: '1px solid',
    color: palette.grey.main,
    backgroundColor: palette.secondary[200],
    borderColor: palette.secondary.main
  },
  // styles to apply on bottom link button
  BtnSuccess: {
    color: palette.secondary['300']
  },
  BtnWarning: {
    color: palette.primary.main
  }
};

export default styles;
